import React,{useState} from 'react'
import './Navbar.scss'
import { images } from '../../constants'
import Scrollbar from 'react-smooth-scrollbar';
import {TiThMenu} from "react-icons/ti";
import {GoEyeClosed} from "react-icons/go";
import { motion } from 'framer-motion'


const Navbar = () => {

const [toggle,setToggle]=useState(false)

  return (
      <nav className='app__navbar'>
    <div className='app__navbar-logo'>
        <img src={images.wglogo} alt='logo'></img>
    </div>
    <ul className='app__navbar-links'>
        {['home', 'About','resume','certification','project','contact'].map((item)=>(
        <li className='app__flex p-text' key={`link-${item}`}>
        <div/>
        <a href={`#${item}`}>{item}</a>
        </li>
        )
    )
  }
    </ul>
    <div className="app__navbar-menu">
      <TiThMenu onClick={()=>setToggle(true)}/>
      {toggle &&(
        <motion.div 
        whileInView={{x:[300,0]}}
        transition={{duration:0.85,ease:'easeOut'}}
        >
          <GoEyeClosed onClick={()=>setToggle(false)}/>
          <ul ul className='app__navbar-links'>
          {['home', 'About','resume','certification','project','contact'].map((item)=>(
            <li key={item}>
            <a href={`#${item}`} onClick={()=>setToggle(false)} > {item}</a>
            </li>
            )
        )
      }
      </ul>
        </motion.div>
      )}
    </div>
    </nav>
  )
} 

export default Navbar